import { Helpers } from "@/global-scripts/helpers";

export class ContentPopup {
  private readonly title: string;
  private readonly content: string;
  private readonly acceptLabel: string;
  private readonly callback: (() => any) | undefined;
  private readonly acceptBtnSelector: string;
  private readonly popupVisibleClass: string;
  private visible = false;
  private popup!: JQuery;
  private acceptBtn!: JQuery;
  private body!: JQuery;

  constructor(title: string, content: string, acceptLabel: string, callback: (() => any) | undefined = undefined) {
    this.popupVisibleClass = "popup-open";
    this.acceptBtnSelector = ".accept-btn";

    this.title = title;
    this.content = content;
    this.acceptLabel = acceptLabel;
    this.callback = callback;

    this.init();
  }

  init() {
    this.popup = this.createPopup();
    this.acceptBtn = $(this.acceptBtnSelector, this.popup);
    this.body = $("body");
    this.body.append(this.popup);
    this.setListeners();
  }

  show() {
    if (this.visible) {
      return;
    }

    Helpers.setScrollBarOffset();
    this.visible = true;
    this.body.addClass(this.popupVisibleClass);
  }

  setListeners() {
    this.acceptBtn.click((e) => {
      e.preventDefault();
      this.body.removeClass(this.popupVisibleClass);
      this.popup.remove();

      Helpers.removeScrollBarOffset();

      if (this.callback) {
        this.callback();
      }
    });
  }

  createPopup() {
    return $(`<div class="ContentPopup">
            <div class="popup-content">
                ${this.title.length > 0 ? `<h3 class="title">${this.title}</h3>` : ""}
                <div class="body">${this.content}</div>
                <a href="#" class="btn accept-btn support">${this.acceptLabel}</a>
            </div>
        </div>`);
  }
}
